

import { ChevronRight, Settings2 } from 'lucide-react';
import { DashboardSpotlight, AIWorkflowSpotlight } from '../dashboard';
import CampaignManagementRender from '../campaign-management/render';
import QuickActions from '../quick-actions';

interface DefaultSpotlightContentProps {
  searchQuery: string;
  onClose: () => void;
  showMoreOptions: boolean;
  setShowMoreOptions: (show: boolean) => void;
  campaignManagementOptions: any[];
}

export const DefaultSpotlightContent = ({
  searchQuery,
  onClose,
  showMoreOptions,
  setShowMoreOptions,
  campaignManagementOptions
}: DefaultSpotlightContentProps) => {
  return (
    <>
      <div data-testid="spotlight-top-cards-section" className="grid grid-cols-2 gap-4 mb-6">
        <DashboardSpotlight />
        <AIWorkflowSpotlight />
      </div>

      <QuickActions
        searchQuery={searchQuery}
        onClose={onClose}
        showMoreOptions={showMoreOptions}
      />

      <CampaignManagementRender
        actions={campaignManagementOptions}
        onClose={onClose}
      />

      <button
        data-testid="spotlight-more-options-button"
        className="w-full flex items-center justify-between px-3 py-2 rounded-lg
          hover:bg-gray-100 dark:hover:bg-gray-700/50
          text-gray-700 dark:text-gray-300 text-sm group"
        onClick={() => setShowMoreOptions(true)}
      >
        <div className="flex items-center gap-2">
          <Settings2 className="w-4 h-4 text-gray-500 dark:text-gray-400" />
          <span>More options</span>
        </div>
        <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300" />
      </button>
    </>
  );
};

export default DefaultSpotlightContent;
